import {DataSource} from '../../../core/data-source/data-source';
import {fromJson} from '../../../core/data-source/json.mapper';
import {httpService} from '../../../core/services/http.service';
import {HistoryRecord} from './history.record';

export class HistoryDataSource<T> extends DataSource<T> {
    async list(params: any, entity?: string): Promise<HistoryRecord[]> {
        return httpService
            .get(`/gt/gt-api/${entity ? entity + '/' : ''}audit`, {params: params})
            .then((response: any) => {
                return response.data.rows.map((list: HistoryRecord) => fromJson(HistoryRecord, list));
            });
    }
}
